const API = {
  BASE_URL: 'https://663896844253a866a24e6014.mockapi.io/api/',
  PRODUCTS_ENDPOINT: 'products',
};

export { API };
